import { useFolder } from 'hooks/queries/folders/useFolder'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useRootStore } from 'stores/RootStore'
import { ProjectMenu } from './ProjectMenu'
import { ProjectMenuContainerProps } from './Types'
import { MovePanel } from './MovePanel'
import Properties from 'screens/Finder/components/ViewPreferences/components/ViewModifierControls/Properties/Properties'
import Sort from 'screens/Finder/components/ViewPreferences/components/ViewModifierControls/Sort/Sort'
import Filter from 'screens/Finder/components/ViewPreferences/components/ViewModifierControls/Filter/Filter'
import Group from 'screens/Finder/components/ViewPreferences/components/ViewModifierControls/Group/Group'

type Panel = 'move' | 'properties' | 'sort' | 'filter' | 'group'

export const ProjectMenuContainer = observer(({ id, onAction, dismiss, ...rest }: ProjectMenuContainerProps) => {
  const [currentPanel, setCurrentPanel] = useState<Panel>()
  const { files } = useRootStore()

  /**
   * This fetching of folder + file is due to the fact that the data is sparse
   * across different endpoints.
   */
  const { data } = useFolder(id, { cacheTime: Infinity })
  const file = files.get(id)
  useEffect(() => {
    files.fetch(id)
  }, [id, files])

  if (!data || !file || !data.folder.handbook) {
    return null
  }

  const {
    database_mode = false,
    default_view,
    default_project = false,
    pinned = false,
    ancestor_projects,
    handbook,
    status_kanban_view_id,
  } = data.folder

  if (currentPanel === 'move') {
    return <MovePanel file={file} dismiss={dismiss} />
  }

  if (currentPanel === 'properties') {
    return <Properties onBackButtonPress={() => setCurrentPanel(undefined)} close={() => setCurrentPanel(undefined)} />
  }

  if (currentPanel === 'sort') {
    return <Sort onBackButtonPress={() => setCurrentPanel(undefined)} />
  }

  if (currentPanel === 'filter') {
    return <Filter onBackButtonPress={() => setCurrentPanel(undefined)} />
  }

  if (currentPanel === 'group') {
    return <Group onBackButtonPress={() => setCurrentPanel(undefined)} />
  }

  return (
    <ProjectMenu
      {...rest}
      folder={{
        key: file.id,
        almanac_file: file,
        pinned,
        ancestor_projects,
        database_mode,
        default_view,
        default_project,
        has_workflow: !!status_kanban_view_id,
        handbook: {
          key: handbook.key,
        },
      }}
      onAction={(action) => {
        if (action === 'move') {
          setCurrentPanel('move')
        }
        if (action === 'properties') {
          setCurrentPanel('properties')
        }
        if (action === 'sort') {
          setCurrentPanel('sort')
        }
        if (action === 'filter') {
          setCurrentPanel('filter')
        }
        if (action === 'group') {
          setCurrentPanel('group')
        }
        onAction?.(action)
      }}
    />
  )
})
